import React from "react";
import { Outlet } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "../components/LandingPage/Navbar";
import Footer from "../components/Common/Footer";
import { useScrollLogic } from "../hooks/useScrollLogic";
import { useTheme } from "../hooks/useTheme";

const MainLayout = () => {
  const { theme, toggleTheme } = useTheme();
  const { scaleX, showBackToTop } = useScrollLogic();

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#0F172A] transition-colors duration-500 font-sans selection:bg-blue-100">
      {/* Scroll Progress Bar */}
      <motion.div 
        className="fixed top-0 left-0 right-0 h-1.5 bg-blue-600 z-[60] origin-[0%]" 
        style={{ scaleX }} 
      />
      
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      {/* Outlet adalah tempat halaman (children) akan muncul */}
      <main className="pt-10 lg:pt-20">
        <Outlet />
      </main>

      <Footer showBackToTop={showBackToTop} />
    </div>
  );
};

export default MainLayout;